import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const LoadingPage = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default LoadingPage;
